import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { RESTDataSource } from "@apollo/datasource-rest";
import config from "@/lib/config";

var Recaptcha = /*#__PURE__*/function (_RESTDataSource) {
  _inherits(Recaptcha, _RESTDataSource);

  var _super = _createSuper(Recaptcha);

  function Recaptcha(options) {
    var _this;

    _classCallCheck(this, Recaptcha);

    _this = _super.call(this, options);
    _this.context = options;
    return _this;
  }

  _createClass(Recaptcha, [{
    key: "willSendRequest",
    value: function willSendRequest(_path, request) {
      request.headers["Content-Type"] = "application/x-www-form-urlencoded";
    }
  }, {
    key: "recaptchaVerifyV2",
    value: function () {
      var _recaptchaVerifyV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(recaptchaTokenV2) {
        var params;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = new URLSearchParams({
                  secret: config.reCAPTCHASecretKey.v2,
                  response: recaptchaTokenV2
                }).toString();
                return _context.abrupt("return", this.post(config.recaptchaVerifyURL, {
                  body: params
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function recaptchaVerifyV2(_x) {
        return _recaptchaVerifyV.apply(this, arguments);
      }

      return recaptchaVerifyV2;
    }()
  }, {
    key: "recaptchaVerifyV3",
    value: function () {
      var _recaptchaVerifyV2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(recaptchaTokenV3) {
        var params;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = new URLSearchParams({
                  secret: config.reCAPTCHASecretKey.v3,
                  response: recaptchaTokenV3
                }).toString();
                return _context2.abrupt("return", this.post(config.recaptchaVerifyURL, {
                  body: params
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function recaptchaVerifyV3(_x2) {
        return _recaptchaVerifyV2.apply(this, arguments);
      }

      return recaptchaVerifyV3;
    }()
  }]);

  return Recaptcha;
}(RESTDataSource);

export default Recaptcha;